interface Props {
  aberto: boolean;
  salvando: boolean;
  incluirSuplentes: boolean;
  aoMudarSuplentes: (v: boolean) => void;
  aoSugerir: () => void;
  aoCancelar: () => void;
}

export default function ModalSugerirTribos({
  aberto,
  salvando,
  incluirSuplentes,
  aoMudarSuplentes,
  aoSugerir,
  aoCancelar,
}: Props) {
  if (!aberto) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/30 sm:items-center sm:p-6">
      <div className="w-full max-w-md rounded-t-3xl bg-white p-6 sm:rounded-3xl">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-accent-100 text-accent-700">
            <i className="ri-magic-line text-xl" aria-hidden />
          </span>
          <h3 className="text-[17px] font-bold leading-tight text-foreground-950">
            Sugerir divisão das tribos
          </h3>
        </div>

        <p className="mt-3 text-[14px] leading-relaxed text-foreground-700">
          O sistema vai sugerir uma tribo para quem ainda não tem, equilibrando homens e mulheres,
          cidade e idade. Nada fica definido até a direção confirmar.
        </p>

        <label className="mt-4 flex cursor-pointer items-center gap-3 rounded-2xl bg-background-50 px-3 py-3">
          <input
            type="checkbox"
            checked={incluirSuplentes}
            onChange={(e) => aoMudarSuplentes(e.target.checked)}
            className="h-4 w-4 cursor-pointer accent-primary-500"
          />
          <span className="text-[13.5px] text-foreground-800">
            Incluir suplentes (lista de espera)
          </span>
        </label>

        <div className="mt-6 flex gap-2">
          <button
            type="button"
            onClick={aoCancelar}
            className="flex-1 cursor-pointer whitespace-nowrap rounded-full border border-background-300 bg-white px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={aoSugerir}
            disabled={salvando}
            className="flex-1 cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600 disabled:opacity-60"
          >
            {salvando ? 'Sugerindo…' : 'Sugerir'}
          </button>
        </div>
      </div>
    </div>
  );
}